var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.809 42.8905C33.6709 42.8905 43.2868 33.2891 43.2868 21.4452C43.2868 9.60136 33.6709 0 21.809 0C9.94705 0 0.331055 9.60136 0.331055 21.4452C0.331055 33.2891 9.94705 42.8905 21.809 42.8905Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_108_48",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7298 18.93H22.1404V24.5561H29.9626C29.2334 28.1303 26.1841 30.1821 22.1404 30.1821C17.3675 30.1821 13.5227 26.3432 13.5227 21.5776C13.5227 16.812 17.3675 12.973 22.1404 12.973C24.1954 12.973 26.0515 13.7011 27.5098 14.8925L31.7524 10.6564C29.1671 8.40596 25.8526 7.01599 22.1404 7.01599C14.053 7.01599 7.55664 13.5025 7.55664 21.5776C7.55664 29.6526 14.053 36.1392 22.1404 36.1392C29.4323 36.1392 36.0612 30.844 36.0612 21.5776C36.0612 20.7171 35.9287 19.7905 35.7298 18.93Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_108_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.23047 30.1822V12.973L17.4997 21.5776L6.23047 30.1822Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_108_48",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 30,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7298 18.93H22.1404V24.5561H29.9626C29.2334 28.1303 26.1841 30.1821 22.1404 30.1821C17.3675 30.1821 13.5227 26.3432 13.5227 21.5776C13.5227 16.812 17.3675 12.973 22.1404 12.973C24.1954 12.973 26.0515 13.7011 27.5098 14.8925L31.7524 10.6564C29.1671 8.40596 25.8526 7.01599 22.1404 7.01599C14.053 7.01599 7.55664 13.5025 7.55664 21.5776C7.55664 29.6526 14.053 36.1392 22.1404 36.1392C29.4323 36.1392 36.0612 30.844 36.0612 21.5776C36.0612 20.7171 35.9287 19.7905 35.7298 18.93Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_108_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.23047 12.9731L17.4997 21.5776L22.14 17.5401L38.0496 14.9587V5.69226H6.23047V12.9731Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_108_48",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 30,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7298 18.93H22.1404V24.5561H29.9626C29.2334 28.1303 26.1841 30.1821 22.1404 30.1821C17.3675 30.1821 13.5227 26.3432 13.5227 21.5776C13.5227 16.812 17.3675 12.973 22.1404 12.973C24.1954 12.973 26.0515 13.7011 27.5098 14.8925L31.7524 10.6564C29.1671 8.40596 25.8526 7.01599 22.1404 7.01599C14.053 7.01599 7.55664 13.5025 7.55664 21.5776C7.55664 29.6526 14.053 36.1392 22.1404 36.1392C29.4323 36.1392 36.0612 30.844 36.0612 21.5776C36.0612 20.7171 35.9287 19.7905 35.7298 18.93Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_108_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.23047 30.1822L26.1174 14.9587L31.3543 15.6206L38.0496 5.69226V37.463H6.23047V30.1822Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_108_48",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 30,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7298 18.93H22.1404V24.5561H29.9626C29.2334 28.1303 26.1841 30.1821 22.1404 30.1821C17.3675 30.1821 13.5227 26.3432 13.5227 21.5776C13.5227 16.812 17.3675 12.973 22.1404 12.973C24.1954 12.973 26.0515 13.7011 27.5098 14.8925L31.7524 10.6564C29.1671 8.40596 25.8526 7.01599 22.1404 7.01599C14.053 7.01599 7.55664 13.5025 7.55664 21.5776C7.55664 29.6526 14.053 36.1392 22.1404 36.1392C29.4323 36.1392 36.0612 30.844 36.0612 21.5776C36.0612 20.7171 35.9287 19.7905 35.7298 18.93Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_108_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0501 37.463L17.5002 21.5776L14.8486 19.5919L38.0501 12.973V37.463Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailLogo);
export default __webpack_public_path__ + "static/media/GmailLogo.8f482c423fb3507bfae923855112d6fa.svg";
export { ForwardRef as ReactComponent };